import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { logoutUser, setAuthenticate, setLocalLogin, setLocalRole, setRefreshToken, setServiceAsync } from 'services/utils/storages/storages';
import { GET_DASHBOARD_COUNT, GET_PROFILE, USER_BY_ID } from './type';

export const userLogin = (email, otp,roleId=null) => async (dispatch) => {

  var fusionState = localStorage.getItem("fusion-state") ? localStorage.getItem("fusion-state") : null;
  const data = {
    email: email,
    otp: otp,
    roleId:roleId,
    fusionState:fusionState,
  };
  const res = await callWebService(
    callTypes.post,
    data,
    Config.loginApiUrl.emailPhoneLogin
  );
  // console.log(res); return false;
  if (res?.data?.status === 0 || res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res.data.response ?? { data: res.data.data };
    const { token, refresh_token } = data;
    const {roleId} = data;
    // await setSession(token);
    setLocalRole(roleId);
    await setLocalLogin(token);
    await setAuthenticate(token);
    await setRefreshToken(refresh_token);
    await setServiceAsync('loginDetails', data);
    // dispatch({ type: AUTHENTICATION, payload: true });
    return res.data.response ?? { status: true, data };
  } else {
    return null;
  }
};

export const getProfile = () => async (dispatch) => {
 var roleId = localStorage.getItem('fusion-role');
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.profileUrl.profile}?roleId=${roleId}`
  );
  if (res) {
    if(res?.data?.status_code == 401){
      return null;
    }
    if(res.data.response.status == false){
      await logoutUser();
      return null;
      
    }
    const { data } = res.data.response;
    localStorage.setItem('profileDetails', JSON.stringify(data.teams));
    localStorage.setItem('roles', JSON.stringify(data.roles));
    dispatch({ type: GET_PROFILE, payload: data });
  } else {
    return null;
  }
};

export const getDashboardCount = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.profileUrl.getDashboardCount
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: GET_DASHBOARD_COUNT, payload: data });
  }
};


export const tryGoogleAuthorisedUserLogin = (data,roleId , pck) => async (dispatch) => {
  const dataData = {
    google_token : data,
    roleId:roleId
  };
  if(pck){
    dataData['package']=pck;
  }
  const res = await callWebService(
    callTypes.post,
    dataData,
   `${Config.loginApiUrl.googleUserLogin}`
  );
  if (res?.data?.status === 0 || res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res.data.response ?? { data: res.data.data };
    const { token, refresh_token } = data;
    const {roleId} = data;
    setLocalRole(roleId);
    await setLocalLogin(token);
    await setRefreshToken(refresh_token);
    await setAuthenticate(token);
    await setServiceAsync('loginDetails', data);
    return res.data.response ?? { status: true, data };
  } else {
    return null;
  }
};

export const userById = (id) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.profileUrl.userById}?id=${id}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: USER_BY_ID, payload: data });
  }
};